import styled from 'styled-components';

const ContentWrapper = styled.div`
  max-width: 100%;
  position: relative;
`;

ContentWrapper.displayName = 'ContentWrapper';

export default ContentWrapper;
